import { Component, OnInit, Input } from '@angular/core';
import { ReconocimientoObj } from 'src/app/_modules/reconocimientos/models/reconocimiento-obj';
import { Router } from '@angular/router';

@Component({
  selector: 'app-reconcocimiento-card-categoria',
  standalone: false,
  templateUrl: './reconcocimiento-card-categoria.component.html',
  styleUrls: ['./reconcocimiento-card-categoria.component.scss']
})
export class ReconcocimientoCardCategoriaComponent implements OnInit {

  @Input()
  hijoId: number;

  @Input()
  boletinesObj: {categoria: string, categoriaDisplay: string, reconocimientos: ReconocimientoObj[]};

  boletinesCard: Array<any>;

  boletinesMas: Array<any>;

  url: Array<string>;

  constructor(private router: Router) {

  }

  ngOnInit() {
    if (this.boletinesObj) {
      const data = this.boletinesObj.reconocimientos;
      this.boletinesCard = data.length === 10 ? data.slice(0, 10) : data.slice(0, 9);
      this.boletinesMas = data.length < 11 ? [] : data.slice(9);
    }
    this.url = this.generateUrl();
  }

  generateUrl(): Array<string> {
    const url = [`/reconocimientos/`];
    if (this.hijoId) {
      url.push('alumno');
      url.push(`${this.hijoId}`);
    }
    if (this.boletinesObj.categoria) {
      url.push('categoria');
      url.push(`${this.boletinesObj.categoria}`);
    }
    return url;
  }
}
